<template>
    <div class="table-result" >
        <p class="table-tit">{{tableTit}}</p>
        <div class="table-cont" v-if="tableType=='statistics'">
            <el-table :data="tableData.slice(0,Math.ceil(tableData.length/2))" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">  
                <el-table-column type="index" label="序号" width="60"> </el-table-column>
                <el-table-column prop="name" label="作者" width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="count" label="发文量/篇" > </el-table-column>   
            </el-table>
            <el-table :data="tableData.slice(Math.ceil(tableData.length/2),tableData.length)" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">  
                <el-table-column label="序号" width="60">
                    <template slot-scope="scope">
                        <p> {{scope.$index+(Math.ceil(tableData.length/2)+1)}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="作者" width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="count" label="发文量/篇" > </el-table-column>   
            </el-table>
        </div>  
        <!-- 关键词词云 -->
        <div class="table-cont" v-if="tableType=='word'">
            <el-table :data="tableData.slice(0,Math.ceil(tableData.length/2))" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">  
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="关键词 "   show-overflow-tooltip></el-table-column> 
                <el-table-column prop="value" label="频次" width="80"> </el-table-column>
                <el-table-column prop="center" label="中心性"   show-overflow-tooltip> </el-table-column>
            </el-table>
            <el-table :data="tableData.slice(Math.ceil(tableData.length/2),tableData.length)" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">  
                <el-table-column label="序号" width="60">
                    <template slot-scope="scope">
                        <p> {{scope.$index+(Math.ceil(tableData.length/2)+1)}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="关键词 "   show-overflow-tooltip></el-table-column> 
                <el-table-column prop="value" label="频次" width="80"> </el-table-column>
                <el-table-column prop="center" label="中心性"   show-overflow-tooltip> </el-table-column>
            </el-table>
        </div>  
        <!-- 关键词共现 -->
        <div class="table-cont" v-if="tableType=='pair'">
            <el-table :data="tableData.slice(0,Math.ceil(tableData.length/2))" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">   
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="keyword1" label="关键词1"   show-overflow-tooltip></el-table-column>
                <el-table-column prop="keyword2" label="关键词2"  show-overflow-tooltip> </el-table-column>   
                <el-table-column prop="count" label="共现频次" width="80"> </el-table-column>
            </el-table>
            <el-table :data="tableData.slice(Math.ceil(tableData.length/2),tableData.length)" 
                border 
                size="small"
                style="width: 50%"
                :header-cell-style="{background:'#396de7',color:'#fff'}">  
                <el-table-column label="序号" width="60">
                    <template slot-scope="scope">
                        <p> {{scope.$index+(Math.ceil(tableData.length/2)+1)}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="keyword1" label="关键词1"   show-overflow-tooltip></el-table-column>
                <el-table-column prop="keyword2" label="关键词2"  show-overflow-tooltip> </el-table-column>   
                <el-table-column prop="count" label="共现频次" width="80"> </el-table-column>
            </el-table>
        </div>  
        <!-- 关键词聚类keyworCurve -->
        <!-- <div class="table-cont" v-if="tableType=='keyworCurve'">
            <el-table :data="tableData" 
                border 
                width='100%'
                size="small" 
                :header-cell-style="{background:'#396de7',color:'#fff'}">    
                <el-table-column prop="cluster_id" width="100" label="类别数"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="size" label="数值" width="100" show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="silhouette_score" label="轮廓系数" width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p>{{ scope.row.silhouette_score?scope.row.silhouette_score.toFixed(3):'' }}</p>
                    </template>
                </el-table-column> 
                <el-table-column prop="top_keywords" label="类别下代表关键词"  show-overflow-tooltip> 
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.top_keywords" :key="index"> 
                            {{item}},
                        </span> 
                    </template>
                </el-table-column>  
                <el-table-column prop="sample_keywords" label="类别的关键词"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.sample_keywords" :key="index"> 
                            {{item}},
                        </span> 
                    </template>
                 </el-table-column>  
            </el-table> 
        </div> -->
         <!-- 关键词突变分析 -->
         <div class="table-cont" v-if="tableType=='mutation'">
            <el-table :data="tableData " 
                border 
                width='100%'
                size="small" 
                :header-cell-style="{background:'#396de7',color:'#fff'}">   
                <el-table-column type="index" label="序号" width="60"></el-table-column> 
                <el-table-column prop="keyword" label="关键词"   show-overflow-tooltip></el-table-column>
                <el-table-column prop="first_appear_year" label="开始出现年份"  show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="mutation_strength" label="突现强度"  show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="start_year" label="突现开始年份"  show-overflow-tooltip> </el-table-column> 
                <el-table-column prop="end_year" label="突现结束年份"  show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="duration" label="突现持续时间"  show-overflow-tooltip> </el-table-column> 
                <el-table-column prop="document_count" label="相关文档数量"  show-overflow-tooltip> </el-table-column>   
            </el-table> 
        </div>
        <!-- 关键词聚类 -->
        <div class="table-cont" v-if="tableType=='keyworCurve'">
            <el-table :data="tableData " 
                border 
                width='100%'
                size="small" 
                :header-cell-style="{background:'#396de7',color:'#fff'}">   
                <!-- <el-table-column type="index" label="序号" width="60"></el-table-column>  -->
                <el-table-column prop="cluster_code" label="聚类编号" width="120"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="representative_keyword" label="聚类代表词"   show-overflow-tooltip></el-table-column>
                <el-table-column prop="core_keyword_count" label="核心关键词数量" width="120" show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="total_frequency" label="核心词总频次" width="120"  show-overflow-tooltip> </el-table-column>  
                <el-table-column prop="avg_betweenness_centrality" label="平均中介中心性" width="140"  show-overflow-tooltip> </el-table-column> 
                <el-table-column prop="avg_occurrence_year" label="平均出现年份" width="120" show-overflow-tooltip> </el-table-column> 
                <el-table-column prop="top5_core_keywords" label="Top5核心关键词"  show-overflow-tooltip> </el-table-column>   
            </el-table> 
        </div>
    </div>
</template>

<script>

export default {
    props:['tableData','tableTit','tableType'],
    components: {},
    data() {
        return {
            
        }
    },
    watch: {},
    mounted() {
        // console.log(this.tableData,'===')
    },
    methods: {
        
    }
}
</script>
<style lang='less' scoped>
.table-result{ 
    width: 1200px ;
    margin:  20px auto 0;
    .table-tit{
        font-size: 16px;
        text-align: center;
        line-height: 32px;
    }
    .table-cont{
        display: flex;
    }
}
</style>